import React from "react";

export const NotFound = () => {
  return (
    <div className="w-full h-full flex justify-around align-middle">
      <h1>NOT FOUND</h1>
    </div>
  );
};
